export default "__VITE_PUBLIC_ASSET__b18ebf82__"